import apiManager from './apiManager'
const getAllAgents = async (pageNumber, activeStatus, userRatings) => {
	let userRatingsQuery = ''
	if (userRatings) {
		userRatings.forEach((rating) => {
			userRatingsQuery += `overallRating[]=${rating}&`
		})
	}

	const allAgents = apiManager.axios
		.get(
			`/v1/admin/agent?${
				pageNumber == null || pageNumber == undefined
					? 'page=' + 1
					: 'page=' + pageNumber
			}&${
				activeStatus !== null && activeStatus !== undefined
					? 'active=' + activeStatus + '&'
					: ''
			}${userRatingsQuery?.length ? userRatingsQuery : ''}`
		)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return allAgents
}
const getSingleAgent = async (id) => {
	const singleAgent = apiManager.axios
		.get(`/v1/admin/agent/${id}`)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return singleAgent
}

const getAllPendingAgents = async (pageNumber = 1) => {
	const allPendingAgents = apiManager.axios
		.get(`v1/admin/agent/pendingAgents?page=${pageNumber}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return allPendingAgents
}

const approveAgent = async (id) => {
	const approve = apiManager.axios
		.patch(`v1/admin/agent/pendingAgents/${id}`)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return approve
}

const reApproveAgent = async (id, reason) => {
	const reApprove = apiManager.axios
		.patch(`v1/admin/agent/${id}/reapproveAgent`, { reason })
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			status: err.response.status
		})
	return reApprove
}

const declineAgent = async (id, reason) => {
	const decline = apiManager.axios
		.patch(`v1/admin/agent/pendingAgents/${id}/declineAgent`, { reason })
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return decline
}

const updateAgentProfile = async (id, updateObj, file) => {
	const formData = new FormData()
	apiManager.axios.defaults.timeout = 20000
	apiManager.axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
	formData.append('id', id)
	formData.append('type', updateObj.type)
	formData.append('firstName', updateObj.firstName)
	formData.append('lastName', updateObj.lastName)
	formData.append('email', updateObj.email)
	formData.append('phone', updateObj.phone)
	formData.append('nickname', updateObj.nickname)
	formData.append('preferredContactTime', updateObj.preferredContactTime)
	formData.append('address', updateObj.address)
	formData.append('skills', JSON.stringify(updateObj.skills))
	formData.append('remote', updateObj.remote)
	formData.append('availableTime', updateObj.availableTime)
	formData.append('pictureUrl', file)
	updateObj.documentUrl.forEach((item) => {
		formData.append('documentUrl', item)
	})
	formData.append(
		'certificateNames',
		JSON.stringify(updateObj.certificateNames)
	)
	const updateAgent = apiManager.axios
		.patch(`/v1/admin/agent/${id}`, formData)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			console.log(err)
		})
	return updateAgent
}

const updateWaitingAgentProfile = async (id, updateObj, file) => {
	const formData = new FormData()
	apiManager.axios.defaults.timeout = 20000
	apiManager.axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
	formData.append('id', id)
	formData.append('type', updateObj.type)
	formData.append('firstName', updateObj.firstName)
	formData.append('lastName', updateObj.lastName)
	formData.append('email', updateObj.email)
	formData.append('phone', updateObj.phone)
	formData.append('address', updateObj.address)
	formData.append('skills', JSON.stringify(updateObj.skills))
	formData.append(
		'certificateNames',
		JSON.stringify(updateObj.certificateNames)
	)
	formData.append('pictureUrl', file)
	const updateAgent = apiManager.axios
		.patch(`/v1/admin/agent/${id}`, formData)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			console.log(err)
		})
	return updateAgent
}
const activateAgent = async (id, reason) => {
	const agentActivation = apiManager.axios
		.patch(`/v1/admin/agent/${id}/activateAgent`, { reason })
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			console.log(err)
		})
	return agentActivation
}

const deactivateAgent = async (id, reason) => {
	const agentDeactivation = apiManager.axios
		.patch(`/v1/admin/agent/${id}/deactivateAgent`, { reason })
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			console.log(err)
		})
	return agentDeactivation
}

const resetAgentPassword = async (id) => {
	const resetPassword = apiManager.axios
		.patch(`/v1/admin/agent/${id}/resetPassword`)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch((err) => {
			console.log(err)
		})
	return resetPassword
}

const agentServiceReport = async (id) => {
	const getserviceReport = apiManager.axios
		.get(`/v1/admin/incident/${id}/report`)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch(() => {
			return { status: 404, data: null }
		})
	return getserviceReport
}
const agentMatchingCertificate = async (type) => {
	const getMatchingCertificate = apiManager.axios
		.get(`/v1/admin/agent/matchingAgents?type=${type}`)
		.then((response) => {
			return { status: 200, data: response.data.data }
		})
		.catch(() => {
			return { status: 404, data: null }
		})
	return getMatchingCertificate
}
const deleteAgent = async (id) => {
	const deleteAgentProfile = apiManager.axios
		.delete(`/v1/admin/agent/${id}`)
		.then((response) => {
			return {
				status: 200,
				data: response.data.data,
			}
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return deleteAgentProfile
}
export default {
	getAllAgents,
	getSingleAgent,
	updateAgentProfile,
	resetAgentPassword,
	getAllPendingAgents,
	approveAgent,
	activateAgent,
	deactivateAgent,
	declineAgent,
	reApproveAgent,
	agentServiceReport,
	updateWaitingAgentProfile,
	agentMatchingCertificate,
	deleteAgent,
}
